export default {
  tagline: 'Your premium destination for digital game keys. Secure, instant, and reliable.',
  nav: {
    shop: 'Shop',
    catalog: 'Catalog',
    support: 'Support',
    supportLink: 'Support',
    faq: 'FAQ',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
  },
  payments: 'We accept',
  nav2: {
    account: 'Account',
    dashboard: 'Dashboard',
    orders: 'Orders',
    wishlist: 'Wishlist',
    platforms: 'Platforms',
  },
  copyright: '© {year} KeyzoStore. All rights reserved.',
  facts: {
    instant: 'Instant delivery',
    receipt: 'PDF receipt per top-up',
    // Plural: 1 key | N keys
    stock: '{count} key in stock | {count} keys in stock',
  },
};
